// extracted by mini-css-extract-plugin
export default {"highlight":"BusinessCodeBanner_highlight__AVk5K"};